/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActionService } from './services/action.service';
import { AuthService } from './services/auth.service';
import { CarrierService } from './services/carrier.service';
import { CatalogSyncService } from './services/catalog-sync.service';
import { CategoryService } from './services/category.service';
import { CmsService } from './services/cms.service';
import { CountryService } from './services/country.service';
import { EnvironmentConfigService } from './services/environment-config.service';
import { InvoiceService } from './services/invoice.service';
import { NotesService } from './services/notes.service';
import { OrdersService } from './services/orders.service';
import { OrderReportService } from './services/order-report.service';
import { PaymentService } from './services/payment.service';
import { ProductService } from './services/product.service';
import { ReportService } from './services/report.service';
import { PublicShopService } from './services/public-shop.service';
import { ResourceService } from './services/resource.service';
import { ShopService } from './services/shop.service';
import { StatusService } from './services/status.service';
import { TasksService } from './services/tasks.service';
import { UserService } from './services/user.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActionService,
    AuthService,
    CarrierService,
    CatalogSyncService,
    CategoryService,
    CmsService,
    CountryService,
    EnvironmentConfigService,
    InvoiceService,
    NotesService,
    OrdersService,
    OrderReportService,
    PaymentService,
    ProductService,
    ReportService,
    PublicShopService,
    ResourceService,
    ShopService,
    StatusService,
    TasksService,
    UserService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
